<template>
  <div :class="$style.recordCharacteristics">
    <div :class="$style.statisticsAndRetell">
      <RecordActions
        v-if="isActionsShown"
        :comments-url="commentsLink"
        :discuss-url="discussUrl"
        :is-bookmarked="isInBookmarks"
        :is-comments-allowed="isCommentsAllowed"
        :comments="comments"
        @clickedComments="emitCommentsClicked"
        @clickedBookmark="emitClickedBookmark"
        @shared="shareRecord($event)"
      >
        <!-- TODO: вернуть блок озвучки REGIONNEWS-30193 -->
        <!-- <div slot="retell" :class="$style.retellContainer">
          <slot name="retell" />
        </div> -->
      </RecordActions>

      <!-- <div v-else :class="$style.retellContainer">
        <slot name="retell" />
      </div> -->
    </div>

    <RecordMobileStickyPanel
      v-if="isStickyPanelShown"
      :isCommentsAllowed="isCommentsAllowed"
      :commentsUrl="commentsUrl"
      :totalComments="comments"
      :isInBookmarks="isInBookmarks"
      :bookmarksUrl="bookmarksUrl"
      @clickedBookmark="emitClickedBookmark"
      @shareRecord="shareRecordInStickyPanel($event)"
      @clickComments="clickCommentsInStickyPanel"
      @linkCopied="sendLinkCopiedRG"
    />
  </div>
</template>

<script>
  import { JtnUiShare, JtnUiBookmark } from '@jtnews/jtn-ui';
  import { RecordActions } from '../record-actions';
  import { RecordMobileStickyPanel } from '../../../../../base/features/record/containers/record-mobile-sticky-panel';
  import { addUrlParams } from '@jtnews/shared/news';

  import { RecordItemUtilsMixin, StoreMixin } from '../../../mixins';
  import { getBreakpointByWindowWidth } from '../../../utils';

  export default {
    name: 'RecordCharacteristics',
    components: {
      JtnUiBookmark,
      JtnUiShare,
      RecordMobileStickyPanel,
      RecordActions
    },
    mixins: [RecordItemUtilsMixin, StoreMixin],
    props: {
      socials: {
        type: Array,
        default() {
          return [];
        }
      },
      comments: {
        type: Number,
        default: 0
      },
      commentsLink: {
        type: String,
        default: '#'
      },
      views: {
        type: Number,
        default: 0
      },
      isCommentsAllowed: {
        type: Boolean,
        default: true
      },
      recordTitle: {
        type: String,
        default: ''
      },
      recordId: {
        type: Number,
        default: 0
      },
      hasRecordContent: {
        type: Boolean,
        default: false
      },
      isInBookmarks: {
        type: Boolean,
        default: false
      },
      isActionsShown: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        obsHalfShareOptions: {
          callback: this.onVisibleShareBlock,
          once: true,
          intersection: {
            threshold: 0.5
          }
        },
        socialLinks: {
          fb: 'FB',
          vk: 'VK',
          twitter: 'TW',
          ok: 'OK',
          telegram: 'TG',
          wa: 'WA'
        },
        deviceType: null
      };
    },
    computed: {
      isMobile() {
        return this.store.deviceInfo.isMobile && !this.store.deviceInfo.isTablet;
      },
      commentsUrl() {
        return this.commentsLink;
      },
      discussUrl() {
        return addUrlParams(this.commentsLink, { discuss: 1 });
      },
      bookmarksUrl() {
        return this.store.commonModule.userInfo
          ? `${this.store.commonModule.userInfo.link}?tab=bookmarks`
          : '';
      },
      regionId() {
        return this.store.regionId;
      },
      isStickyPanelShown() {
        return this.store.deviceInfo.isMobile || this.deviceType === 'tablet';
      }
    },
    mounted() {
      this.deviceType = getBreakpointByWindowWidth(window.innerWidth);
    },
    methods: {
      formatNumber(number) {
        return number.toLocaleString('ru-RU');
      },
      emitCommentsClicked() {
        this.$emit('clickedCommentsLink');
      },
      emitClickedBookmark() {
        this.$emit('clickedBookmark');
        this.$emit('clickedBookmarkInStickyPanel');
      },
      onVisibleShareBlock(isVisible) {
        if (isVisible && this.hasRecordContent) {
          this.$emit('viewShareBlock');
        }
      },
      shareRecord($event) {
        const socialName = this.socialLinks[$event];

        this.$emit('shareBlock', socialName);

        this.store.sharingModule.shareRecord({
          socialTarget: $event,
          title: this.recordTitle,
          utmParams: this.store.sharingModule.getUtmParams(
            'sharetexttop',
            `${this.recordId}`,
            this.regionId
          )
        });
      },
      shareRecordInStickyPanel($event) {
        this.$emit('shareRecordInStickyPanel', $event);
        this.shareRecord($event);
      },
      clickCommentsInStickyPanel() {
        this.$emit('clickCommentsInStickyPanel');
      },
      sendLinkCopiedRG() {
        this.$emit('linkCopiedInStickyPanel');
      }
    }
  };
</script>

<style lang="scss" module>
  @import 'styles';

  .statisticsAndRetell {
    display: none;

    @include on-min-resize($laptop) {
      display: block;
    }

    width: 100%;

    @include on-min-resize($laptop) {
      width: auto;
    }
  }

  // .retellContainer {
  //   & > div {
  //     height: 48px;
  //     margin: 24px 0 0;

  //     @include on-min-resize($tablet) {
  //       width: 206px;
  //       height: 48px;
  //       margin: 0 0 0 16px;

  //       & :global(.retell-frame) {
  //         height: 48px !important;
  //       }
  //     }
  //   }
  // }
</style>
